// extracted by mini-css-extract-plugin
export default {"btn":"SliderArrow_btn__jzFmP","right":"SliderArrow_right__4SEwz","left":"SliderArrow_left__zLMik"};